module.exports = __webpack_public_path__ + "static/veterinarian-8fbeaca994efe4de2fc3433d8f8c1560.jpg";